"use client";

import React from 'react'
import dynamic from 'next/dynamic';
import HeaderDesktop from './desktop/HeaderDesktop'

// Mobile-only header — dynamic + ssr:false so its module code is NOT evaluated
// on desktop viewports during SSR/hydration (reduces TBT on desktop).
const BlogHeader = dynamic(() => import('./blog/mobile/BlogHeader'), { ssr: false });

const HeaderLandingPage = ({
  heroRef,
  backgroundVariant = "transparent",
}) => {
  return (
    <>
      {/* Mobile Header */}
      <div className="lg:hidden">
        <BlogHeader />
      </div>
      
      {/* Desktop Header */}
      <div className="hidden lg:block">
        <HeaderDesktop heroRef={heroRef} backgroundVariant={backgroundVariant} />
      </div>
    </>
  );
}

export default HeaderLandingPage
